import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { Banner } from "../../shared/models/banner";
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { RecaptchaLoaderService } from "../../utils/recaptchaLoader.service";
import { AuthorizationService } from "../authorization/authorization.service";

import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";



declare var grecaptcha: any;
export enum CheckBoxType { 
  Option1, 
  Option2,
  Option3, 
  NONE 
};

@Component({
    selector: "app-ccpa",
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './ccpa.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class CCPAComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  isFrench = false;
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  azURL: string;
  baseRedirect = '';
  countryFlag: string;
  langFlag: string;
  bodyLoaded = false;
  accountRedirect = '';
  token: string;
  currentlyChecked: CheckBoxType;
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  environment = '';
  siteKeyCaptcha = '';
  recaptchaResponse = '';
  rendered: any;
  captchaToggle = true;
  // Recaptcha related variables
  // lOCAL TESTING SITE KEY
  // siteKeyCaptcha = '6LdgbbUUAAAAADONNVKQp3CrnGq_C7RsQsmwvB6l';
  // Captcha URL
  // private recaptchaURL = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
  // MBFS SITE KEY
  // siteKeyCaptcha = '6LcSOLUUAAAAAJEjAl9EcW4zmRc9G4W1HJ5u4tkJ';
  // siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptcha;
  private recaptchaURL = APP_CONSTANTS.recaptchaURL;

  //ccpaValues
  selectedCommunication: string;
  communicationTypes: string[] = ['Mail', 'Email'];
  customerCheckbox1 =false;
  customerCheckbox2 =false;
  successCCPA = false;
  customerCheckbox3 =false;
  customerRights1 =false;
  customerRights2=false;
  disclaimer=false;
  buyer=false;
  guarantor=false;
  hasNumeric = false;
  phoneLength = false;
  phoneValid =false;
  ssnLength = false;
  ssnValid = false;
  showPhoneErrors = false;
  showSsnErrors = false;
  accounts="";
  first_name="";
  last_name="";
  ssn="";
  phone="";
  address="";
  apt="";
  city="";
  state="";
  zipcode="";
  email="";
  reemail="";
  reentercheck = false;
  reenteremailcheck=false;
  ccpaForm: FormGroup;
  ciamReCaptchaForm: FormGroup;
  formValidationClasses = {
    'mbfs-error': true,
  };

  buildForm() {
    this.ccpaForm = this.fb.group({
      accounts: [''],
      first_name: [''],
      last_name: [''],
      ssn: [''],
      phone: [''],
      address: [''],
      apt: [''],
      city: [''],
      state: [''],
      zipcode: [''],
      email: [''],
      reemail: ['']
     });

    this.ciamReCaptchaForm = this.fb.group({
      recaptchaResponseKey: [null, Validators.required]
  });
  }


  constructor(
    router: Router,
    public auth: AuthorizationService,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil,
    private fb: FormBuilder,
   public recaptchaLoaderService: RecaptchaLoaderService
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    //this.getAlerts();
    this.langInit();
    let element: HTMLElement = document.getElementById('auto_triggerccpa') as HTMLElement;
    element.click();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    const usePrivacy = (window as any).mbfs.usePrivacy;
  }
  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
         
           if (redirect === 'useAndPrivacy'){
            this.azURL =  this.usUrl + '/ca/fr/home/useAndPrivacy';
          }
          else if (redirect ==='ccpa'){
            this.azURL =  this.usUrl + '/ca/fr/home/ccpa';
          }
         
      }
      else{
        if (redirect === 'useAndPrivacy'){
          this.azURL =  this.usUrl + '/ca/en/home/useAndPrivacy';
        }
        else if (redirect ==='ccpa'){
          this.azURL =  this.usUrl + '/ca/en/home/ccpa';
        }
      }
    }
    else{ //US Logic
      this.azURL =  this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'useAndPrivacy'){
        this.azURL =  this.usUrl + '/home/useAndPrivacy';
      }
    
      else if (redirect ==='ccpa'){
        this.azURL =  this.usUrl + '/home/ccpa';
      }

    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
  }, 1000);  //1s
  }
  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }
  selectSiteKey() {
    this.environment = (this._window.nativeWindow as any).mbfs.environment;
    if (this.environment === 'local') {
     this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaLocal;
    } else if (this.environment === 'dev') {
      this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaDev;
    } else if (this.environment === 'stage') {
      this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaStage;
    } else if (this.environment === 'prod') {
      this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
    } else {
      this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
    }
  }

  onloadCallback() {
    this.rendered = grecaptcha.render('capcha_element', {
        'sitekey': this.siteKeyCaptcha,
        'lang': this.language
    });
}


  getResponceCapcha(captchaResponse: string) {
    // this.verifyCaptcha(captchaResponse);
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(captchaResponse);
    (this._window.nativeWindow as any).scrollBy(0, 1);
    this.recaptchaResponse = this.ciamReCaptchaForm.controls.recaptchaResponseKey.value;
}

recaptchaResponseExpired() {
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
    grecaptcha.reset(this.rendered);
}
recaptchaError() {
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
    this.translate.get('Errors.recaptcha').subscribe((data: any) => {
      this.serviceErrorDesc = data;
     });
}

  onClickLogin(e: Event): void {
    this.buildForm();
    this.openLoginModal = true;
    this.successCCPA = false;
    this.selectSiteKey(); // used to set Site key based on environment
    //recaptcha script load
    if(this.language === 'fr-CA') {
      this.recaptchaURL = APP_CONSTANTS.recaptchaURLFR;
    } else {
      this.recaptchaURL = APP_CONSTANTS.recaptchaURL;
    }
    if (this.captchaToggle) {
    window['onloadCallback'] = this.onloadCallback.bind(this);
    window['getResponceCapcha'] = this.getResponceCapcha.bind(this);
    window['recaptchaResponseExpired'] = this.recaptchaResponseExpired.bind(this);
    window['recaptchaError'] = this.recaptchaError.bind(this);

    this.recaptchaLoaderService.loadScript(this.recaptchaURL)
        .then(data => {
        }).catch(error => console.log(error));
    }
    //build login form
    // this.ccpaForm.get('first_name').setValidators(
    //   Validators.compose([Validators.required,
    //        Validators.minLength(8),
    //        Validators.maxLength(60)])
    // );
    // this.ccpaForm.get('last_name').setValidators(
    //   Validators.compose([Validators.required,
    //        Validators.minLength(8),
    //        Validators.maxLength(60)])
    // );
    // this.ccpaForm.get('ssn').setValidators(
    //   Validators.compose([Validators.required])
    // );
    // this.ccpaForm.get('address').setValidators(
    //   Validators.compose([Validators.required])
    // );
    // this.ccpaForm.get('city').setValidators(
    //   Validators.compose([Validators.required])
    // );
    // this.ccpaForm.get('state').setValidators(
    //   Validators.compose([Validators.required])
    // );
    // this.ccpaForm.get('zipcode').setValidators(
    //   Validators.compose([Validators.required])
    // );
    }

    public onValueChange(event: Event): void {
      const value = (event.target as any).value;
      this.accounts = value;
    }
    public onRadioChange(event: Event): void {
      const value = (event.target as any).value;
      this.selectedCommunication = value;
      event.stopPropagation();
    }

    public inputValidator(event: any) {
      this.showPhoneErrors = true;
      let phonevalue = event.target.value;
    
      this.hasNumeric = /^\d+$/.test(phonevalue);
      this.phoneLength = (phonevalue.length === 10);
      this.phoneValid = this.phoneLength && this.hasNumeric;    
    }

    public ssnValidator(event: any) {
      this.showSsnErrors = true;
      let ssnvalue = event.target.value;
    
      this.hasNumeric = /^\d+$/.test(ssnvalue);
      this.ssnLength = (ssnvalue.length === 4);
      this.ssnValid = this.ssnLength && this.hasNumeric;    
    }

    // EqualsCheck(): ValidatorFn {
    //   return (control: AbstractControl): ValidationErrors | null => {
    //     let email1value = this.ccpaForm.get('email').value;
    //     let email2value = this.ccpaForm.get('reemail').value;
    //     let notemailEqual = false;
    //     if (email1value === email2value) {
    //       notemailEqual = true;
    //     }
    //     this.reenteremailcheck = notemailEqual;
    //     const emailValid = this.reenteremailcheck;
    //     return !emailValid ? { mailStrength: true } : null;
    //   }
    // }

    timeoutError(){
      this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 5000);  //2s
        return;
    }

    submitCCPA(event: Event){

      if (!this.ccpaForm.valid) {
        this.serviceErrorDesc = "Please complete the mandatory fields";
        this.timeoutError();
        return;
      }
      this.first_name = this.ccpaForm.get('first_name').value;
      this.last_name = this.ccpaForm.get('last_name').value;
      this.ssn = this.ccpaForm.get('ssn').value;
      this.phone = this.ccpaForm.get('phone').value;
      this.address = this.ccpaForm.get('address').value;
      this.apt = this.ccpaForm.get('apt').value;
      this.city = this.ccpaForm.get('city').value;
      this.state = this.ccpaForm.get('state').value;
      this.zipcode = this.ccpaForm.get('zipcode').value;
      this.email = this.ccpaForm.get('email').value;
      this.reemail = this.ccpaForm.get('reemail').value;
      let result1 = this.customerCheckbox1 ? "Y" : "N";
      let result2 = this.customerCheckbox2 ? "Y" : "N";
      let result3 = this.customerCheckbox3 ? "Y" : "N";
      let result4 = this.customerRights1 ? "Y" : "N";
      let result5 = this.customerRights2 ? "Y" : "N";
      let result6 = this.buyer ? "Y" : "N";
      let result7 = this.guarantor ? "Y" : "N";
      let result8 = this.disclaimer ? "Y" : "N";

      if(!this.selectedCommunication) 
      {
        this.serviceErrorDesc = "Please complete the mandatory fields";
        this.timeoutError();
        return;
      }
      else if([this.customerCheckbox1, this.customerCheckbox2, this.customerCheckbox3].filter(Boolean).length <= 0 )
      {
        this.serviceErrorDesc = "Please complete the mandatory fields";
        this.timeoutError();
        return;
      }
      else if((result4 !="Y") && (result5 !="Y"))
      {
        this.serviceErrorDesc = "Please complete the mandatory fields";
        this.timeoutError();
        return;
      }
      else if(result8 != "Y"){
        this.serviceErrorDesc = "Please complete the mandatory fields";
        this.timeoutError();
        return;
      }
      else if (this.email != this.reemail) {
        this.serviceErrorDesc = "Please complete the mandatory fields";
        this.timeoutError();
      }

    const ccpaRequest = {
    accountNbr: this.accounts,
    requesterfName: this.first_name,
    requesterLName: this.last_name,
    requesterAddressLine1: this.address,
    requesterAddressLine2: this.apt,
    requesterCity: this.city,
    requesterState: this.state,
    requesterZip: this.zipcode,
    requesterPhoneNbr: this.phone,
    requesterSSN: this.ssn,
    requestMethod: this.selectedCommunication,
    requestEmail: this.email,
    chkBoxA: result1,
    chkBoxB:result2,
    chkBoxC:result3,
    chkBoxR1:result4,
    chkBoxR2:result5,
    requesterTypeBuyer:result6,
    requesterTypeGuar: result7
    };

      this.auth.submitCCPA(ccpaRequest).subscribe(res => {
        if(res.statusMessage==='SUCCESS')
        {
          this.successCCPA = true;
        }
        else{
          this.serviceErrorDesc = "Error with Backend verifyUserId";
          this.timeoutError();
        }
      });
    }

    openLogin(e: Event) {
      this.openLoginModal = false;
      this.serviceErrorOccurred = false;
      let redirect = '';
      this.translate.get('LoginModal.LoginRedirect').subscribe((data:any)=> {
        redirect= this.usUrl +  data;
       });
       window.location.href = redirect;
    }


}
